export const NoticeOfSaleFormModal = ({ handleCancel }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div
        style={{
          maxWidth: "560px",
          backgroundImage: "none",
        }}
        className="schedule-form-wrapper"
      >
        <div
          style={{
            position: "relative",
          }}
          className="schedule-form-header"
        >
          <p>Notice of Sale</p>
        </div>

        <div
          style={{
            width: "100%",
            padding: "32px  16px",
            position: "relative",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
          className="sale-form-container"
        >
          <div>
            <p
              style={{
                color: "#282828",
              }}
            >
              <span
                style={{
                  fontWeight: "600",
                  paddingRight: "8px",
                }}
              >
                Suit number:
              </span>
              ID/ADR/1470/2020
            </p>
          </div>

          <div className="sale-container">
            <div className="sale-schedule-wrapper">
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Sale Schedule
              </p>
              <div className="schedule-input-wrapper notice-time-date-wrapper">
                <div className="dt-input-wrapper">
                  <label htmlFor="date">Date</label>
                  <input type="date" id="date" />
                </div>
                <div className="dt-input-wrapper">
                  <label htmlFor="time">Time</label>
                  <input type="time" id="time" />
                </div>
              </div>
              <div>
                <div className="sale-location-wrapper">
                  <label htmlFor="saleLocation">Sale Location </label>
                  <input type="text" id="saleLocation" />
                </div>
              </div>

              <div className="attaches-good-wrapper">
                <label htmlFor="goods">Attached Goods Description</label>
                <textarea
                  id="goods"
                  placeholder="Describe the goods to be sold (e.g., vehicle make/model, furniture items, equipment, etc.)"
                ></textarea>
              </div>
              <div className="sale-location-wrapper">
                <label htmlFor="bidAmount">Minimum bid Amount</label>
                <input type="number" id="bidAmount" placeholder="NGN" />
              </div>
            </div>
          </div>
          <div className="sale-container">
            <div className="sale-schedule-wrapper">
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Judgment Debtor Notification{" "}
              </p>
              <div className="sale-location-wrapper">
                <label htmlFor="debtorName">Debtor Name</label>
                <input
                  type="text"
                  id="debtorName"
                  placeholder="Enter Debtor’s name"
                />
              </div>
              <div className="sale-location-wrapper">
                <label htmlFor="contact">Contact (Phone/Email) </label>
                <input
                  type="text"
                  id="contact"
                  placeholder="Enter phone number or email"
                />
              </div>
              <p
                style={{
                  fontSize: "14px",
                  color: "#282828",
                }}
              >
                The notice will be published for at least 3 days in a
                conspicuous part of the courthouse.
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: "0px",
              justifyContent: "flex-start",
            }}
            className="assign-case-button-group"
          >
            <button
              style={{
                maxWidth: "132px",
              }}
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              style={{
                maxWidth: "224px",
              }}
            >
              Publish and Notify
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
